var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-icons"},_vm._l((_vm.icons),function(icon){return _c('SocialIcon',{key:icon.id,attrs:{"icon":icon,"color":"text-color-white"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }